 <template>
  <div class="d-flex flex-column pt-10">
    <v-form @submit.prevent="submit" class="d-flex flex-column align-center">
      <div class="d-flex">
        <div class="d-flex flex-column flex-grow-1 px-10">
          <p>ΠΛΗΡΟΦΟΡΙΕΣ ΠΤΗΣΗΣ</p>
          <v-text-field
            class="flex-grow-0"
            label="Όνομα αεροπορικής εταιρίας"
            v-model="formJsonText.flightInfo.companyName"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Αριθμός πτήσης"
            v-model="formJsonText.flightInfo.flightNo"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Αριθμός θέσης"
            v-model="formJsonText.flightInfo.seatNo"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Ημερομηνία άφιξης"
            v-model="formJsonText.flightInfo.arrivalDate"
          ></v-text-field>

          <p>ΠΡΟΣΩΠΙΚΑ ΣΤΟΙΧΕΙΑ</p>
          <v-text-field
            class="flex-grow-0"
            label="Επίθετο"
            v-model="lastName"
            :error-messages="lastNameErrors"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Όνομα"
            v-model="firstName"
            :error-messages="firstNameErrors"
          ></v-text-field>
          <v-text-field
            label="Ημερ. γέννησης / Date of birth"
            hint="(ημ./μήνας/έτος   dd/mm/yyyy)"
            v-model="formJsonText.personalInfo.dateOfBirth"
          ></v-text-field>
          <v-text-field
            label="ΕΘνικότητα / Nationality"
            v-model="formJsonText.personalInfo.nationality"
          ></v-text-field>
          <v-select
            class="flex-grow-0"
            label="Φύλο"
            :items="['Αντρας', 'Γυναίκα']"
            v-model="formJsonText.personalInfo.gender"
          ></v-select>
          <v-radio-group
            v-model="formJsonText.personalInfo.idType"
            label="Συμπληρώστε το ΑΜΚΑ ή ελλείψει αυτού άλλο ταυτοποιητικό έγγραφο / Select ONE of the following"
          >
            <v-radio label="AMKA" value="amka"></v-radio>
            <v-radio label="Δελτίο Ταυτότητας / ID Card" value="idCard"></v-radio>
            <v-radio label="Διαβατήριο / Passport" value="passport"></v-radio>
          </v-radio-group>
          <v-text-field
            label="Αριθμός / Above number"
            hint="Συμπληρώστε τον αριθμό του ανωτέρω εγγράφου / Fill in the above number"
            v-model="formJsonText.personalInfo.idNumber"
          ></v-text-field>

          <p>ΣΤΟΙΧΕΙΑ ΕΠΙΚΟΙΝΩΝΙΑΣ</p>
          <v-text-field
            class="flex-grow-0"
            label="Κινητό"
            v-model="formJsonText.contactInfo.mobile"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Σταθερό"
            v-model="formJsonText.contactInfo.phone"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Email"
            v-model="email"
            :error-messages="emailErrors"
          ></v-text-field>

          <p>ΜΟΝΙΜΗ ΔΙΕΥΘΥΝΣΗ</p>
          <v-text-field
            class="flex-grow-0"
            label="Αριθμός και Οδός"
            hint="Αφήστε κενό ανάμεσα στον αριθμό και την οδό"
            v-model="formJsonText.permanentAddress.streetAndNumber"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Πόλη"
            v-model="formJsonText.permanentAddress.city"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Χώρα"
            v-model="formJsonText.permanentAddress.country"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Ταχυδρομικός Κώδικας"
            v-model="formJsonText.permanentAddress.postalCode"
          ></v-text-field>

          <p>ΠΡΟΣΩΡΙΝΗ ΔΙΕΥΘΥΝΣΗ</p>
          <p class="caption">Αν είστε επισκέπτης, συμπληρώστε το πρώτο μέρος στο οποίο θα μείνετε</p>

          <v-text-field
            class="flex-grow-0"
            label="Όνομα ξενοδοχείου"
            hint="εάν υπάρχει"
            v-model="formJsonText.temporaryAddress.hotelName"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Αριθμός και Οδός"
            hint="Αφήστε κενό ανάμεσα στον αριθμό και την οδό"
            v-model="formJsonText.temporaryAddress.streetAndNumber"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Αριθμός διαμερίσματος"
            v-model="formJsonText.temporaryAddress.appartmentNo"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Πόλη"
            v-model="formJsonText.temporaryAddress.city"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Περιφέρεια"
            v-model="formJsonText.temporaryAddress.region"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Χώρα"
            v-model="formJsonText.temporaryAddress.country"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Ταχυδρομικός Κώδικας"
            v-model="formJsonText.temporaryAddress.postalCode"
          ></v-text-field>
        </div>

        <div class="d-flex flex-column flex-grow-1 px-10">
          <p>ΣΤΟΙΧΕΙΑ ΕΠΙΚΟΙΝΩΝΙΑΣ ΕΚΤΑΚΤΗΣ ΑΝΑΓΚΗΣ</p>
          <p
            class="caption"
          >Καποιου ο οποιός θα μπορεί να επικοινωνήσει μαζί σας τις επόμενες 30 ημέρες</p>
          <v-text-field
            class="flex-grow-0"
            label="Επίθετο"
            v-model="formJsonText.emergencyContactInfo.lastName"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Όνομα"
            v-model="formJsonText.emergencyContactInfo.firstName"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Πόλη"
            v-model="formJsonText.emergencyContactInfo.city"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Χώρα"
            v-model="formJsonText.emergencyContactInfo.country"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Email"
            v-model="formJsonText.emergencyContactInfo.email"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Κινητό τηλέφωνο"
            v-model="formJsonText.emergencyContactInfo.mobile"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Άλλα τηλέφωνα"
            v-model="formJsonText.emergencyContactInfo.otherPhone"
          ></v-text-field>

          <p>ΤΑΞΙΔΙΩΤΙΚΟΣ ΣΥΝΟΔΟΣ - ΟΙΚΟΓΕΝΕΙΑ</p>
          <p class="caption">Συμπεριλάβετε την ηλικία μόνο για άτομα κάτω των 18 ετών</p>
          <v-text-field class="flex-grow-0" label="Επίθετο" v-model="formJsonText.family.lastName"></v-text-field>
          <v-text-field class="flex-grow-0" label="Όνομα" v-model="formJsonText.family.firstName"></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Αριθμός θέσης"
            v-model="formJsonText.family.seatNo"
          ></v-text-field>
          <v-text-field class="flex-grow-0" label="Ηλικία < 18" v-model="formJsonText.family.age"></v-text-field>

          <p>ΣΤΟΙΧΕΙΑ ΧΩΡΟΥ ΑΠΟΜΟΝΩΣΗΣ ΓΙΑ ΤΙΣ ΕΠΟΜΕΝΕΣ 14 ΗΜΕΡΕΣ</p>
          <p>ΔΙΕΥΘΥΝΣΗ</p>
          <v-text-field
            class="flex-grow-0"
            label="Αριθμός και Οδός"
            hint="Αφήστε κενό ανάμεσα στον αριθμό και την οδό"
            v-model="formJsonText.quarantinePlace.streetAndNumber"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Πόλη"
            v-model="formJsonText.quarantinePlace.city"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Περιφέρεια"
            v-model="formJsonText.quarantinePlace.region"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Ταχυδρομικός Κώδικας"
            v-model="formJsonText.quarantinePlace.postalCode"
          ></v-text-field>
        </div>
      </div>

      <v-btn color="primary" type="submit">ΕΠΟΜΕΝΟ</v-btn>
    </v-form>
  </div>
</template>

<script>
import { required, email, numeric } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      lastName: this.$store.state.frontDesk.newTouristTest?.lastName,
      firstName: this.$store.state.frontDesk.newTouristTest?.firstName,
      passportNo: "nothing",
      email: this.$store.state.frontDesk.newTouristTest?.email,
      formJsonText: {
        flightInfo: {
          companyName: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.flightInfo?.companyName,
          flightNo: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.flightInfo?.flightNo,
          seatNo: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.flightInfo?.seatNo,
          arrivalDate: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.flightInfo?.arrivalDate
        },
        personalInfo: {
          dateOfBirth: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.personalInfo?.dateOfBirth,
          nationality: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.personalInfo?.nationality,
          gender: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.personalInfo?.gender,
          idType: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.personalInfo?.idType,
          idNumber: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.personalInfo?.idNumber
        },
        contactInfo: {
          mobile: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.contactInfo?.mobile,
          phone: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.contactInfo?.phone
        },
        permanentAddress: {
          streetAndNumber: this.$store.state.frontDesk.newTouristTest
            ?.formJsonText?.permanentAddress?.streetAndNumber,
          city: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.permanentAddress?.city,
          country: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.permanentAddress?.country,
          postalCode: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.permanentAddress?.postalCode
        },
        temporaryAddress: {
          hotelName: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.temporaryAddress?.hotelName,
          streetAndNumber: this.$store.state.frontDesk.newTouristTest
            ?.formJsonText?.temporaryAddress?.streetAndNumber,
          appartmentNo: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.temporaryAddress?.appartmentNo,
          city: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.temporaryAddress?.city,
          region: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.temporaryAddress?.region,
          country: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.temporaryAddress?.country,
          postalCode: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.temporaryAddress?.postalCode
        },
        emergencyContactInfo: {
          lastName: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.emergencyContactInfo?.lastName,
          firstName: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.emergencyContactInfo?.firstName,
          city: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.emergencyContactInfo?.city,
          country: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.emergencyContactInfo?.country,
          email: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.emergencyContactInfo?.email,
          mobile: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.emergencyContactInfo?.mobile,
          otherPhone: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.emergencyContactInfo?.otherPhone
        },
        family: {
          lastName: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.family?.lastName,
          firstName: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.family?.firstName,
          seatNo: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.family?.seatNo,
          age: this.$store.state.frontDesk.newTouristTest?.formJsonText?.family
            ?.age
        },
        quarantinePlace: {
          streetAndNumber: this.$store.state.frontDesk.newTouristTest
            ?.formJsonText?.quarantinePlace?.streetAndNumber,
          city: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.quarantinePlace?.city,
          region: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.quarantinePlace?.region,
          postalCode: this.$store.state.frontDesk.newTouristTest?.formJsonText
            ?.quarantinePlace?.postalCode
        }
      }
    };
  },

  methods: {
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const credentials = {
          caseCode: "",
          orgCode: this.orgCode,
          lastName: this.lastName,
          firstName: this.firstName,
          passportNo: this.passportNo,
          email: this.email,

          formJsonText: {
            flightInfo: this.formJsonText.flightInfo,
            personalInfo: this.formJsonText.personalInfo,
            contactInfo: this.formJsonText.contactInfo,
            temporaryAddress: this.formJsonText.temporaryAddress,
            emergencyContactInfo: this.formJsonText.emergencyContactInfo,
            family: this.formJsonText.family,
            quarantinePlace: this.formJsonText.quarantinePlace
          }
        };
        this.$store.dispatch("newTouristTestFirst", credentials);
      }
    }
  },

  validations: {
    email: { required, email },
    firstName: { required },
    lastName: { required }
  },

  computed: {
    reportingUnitErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.reportingUnit.required) errors.push("Required");

      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.required) errors.push("Required");
      if (!this.$v.email.email) errors.push("must be valid email");

      return errors;
    },


    firstNameErrors() {
      const errors = [];
      if (!this.$v.firstName.$dirty) return errors;
      if (!this.$v.firstName.required) errors.push("Required");
      return errors;
    },

    lastNameErrors() {
      const errors = [];
      if (!this.$v.lastName.$dirty) return errors;
      if (!this.$v.lastName.required) errors.push("Required");
      return errors;
    }
  }
};
</script>
